<template>
    <modal ref="modalEditarTermino" tamano="modal-xl" titulo="Editar término" no-aceptar adicional="Guardar" @adicional="editarTermino">
        <ValidationObserver ref="formHija">
                <div class="row mx-0 j-center">
                    <div class="col-12 mb-1 mt-2">
                        <p class="label pl-3">
                            Nombre del término
                        </p>
                        <ValidationProvider v-slot="{errors}" rules="required|max:80" name="nombre">
                            <el-input v-model="termino.titulo" class="w-100" placeholder="Nombre" maxlength="80" show-word-limit size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 mt-2 mb-2">
                        <p class="label pl-3">
                            Descripción
                        </p>
                        <ValidationProvider v-slot="{errors}" name="descripción">
                            <el-input v-model="termino.respuesta" placeholder="Descripción"  type="textarea" :rows="25" show-word-limit class="w-100" size="small" />
                            <p class="text-danger f-10">{{ errors[0] }}</p>
                        </ValidationProvider>
                    </div>
                </div>
        </ValidationObserver>
    </modal>
</template>

<script>
import Configuracion from '@/services/configuracion'
export default {
    data(){
        return {
            termino: {
                id: null,
                titulo: '',
                respuesta: '',
            },
        }
    },
    methods: {
        toggle(termino){
            this.termino = termino
            this.$refs.modalEditarTermino.toggle();
        },
        async editarTermino(){
            try {
                
                let validate = await this.$refs.formHija.validate()
                if(!validate) return this.notificacion('','Campos incompletos')

                let params = {
                    id_faq: this.termino.id,
                    titulo: this.termino.titulo,
                    respuesta: this.termino.respuesta
                }
                
                const { data } = await Configuracion.editarFaq(params)

                this.notificacion('','Término editado correctamente','success')
                this.$refs.modalEditarTermino.toggle();
                
                this.$emit('actualizar')
            } catch (error) {
                this.error_catch(error)
            }
        },

    }
}
</script>
<style lang="scss" scoped>
.label{
    font-size: 12px;
    color: var(--text-general);
}
</style>